import React from 'react'

const Frontsound = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M16.9948 10.515C18.3351 11.3805 18.3351 13.62 16.9948 14.4855L8.90246 19.7107C7.60123 20.553 6 19.458 6 17.7262V7.27498C6 5.54248 7.60048 4.44823 8.90246 5.28898L16.9948 10.515Z" stroke="currentColor" strokeWidth="1.8"></path>
<path d="M21 7.24951V17.7495" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8"></path>
</svg>
    )
}

export default Frontsound
